import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-vue" }
const _hoisted_2 = { class: "footer" }

import PageViews from '@/views/PageViews.vue'
  import PageFooter from './components/PageFooter/PageFooter.vue';
  import NavBarMain from './components/PageNavBar/NavBarMain.vue';
  import AgeChecker from './components/UI/AgeChecker.vue';

  // console.log(process.env.VUE_APP_CLIENT_ID)
  // console.log(process.env.VUE_APP_REDIRECT_URI)



export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  const _component_Notifications = _resolveComponent("Notifications")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Notifications, {
      group: "notification",
      position: "top right",
      class: "notify",
      speed: 500
    }),
    _createVNode(NavBarMain),
    _createVNode(PageViews),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PageFooter)
    ]),
    _createVNode(AgeChecker)
  ]))
}
}

})